/**
 * 判断参数的类型
 * @param {*} obj
 * @returns {String}
 */
function typeOf (obj) {
  const toString = Object.prototype.toString
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  return map[toString.call(obj)]
}
/**
 * 深拷贝
 * @param {*} data
 * @returns {*}
 */
export function deepCopy (data) {
  const t = typeOf(data)
  let o
  if (t === 'array') {
    o = []
    for (let i = 0, index = data.length; i < index; i++) {
      o.push(deepCopy(data[i]))
    }
  } else if (t === 'object') {
    o = {}
    for (let i in data) {
      o[i] = deepCopy(data[i])
    }
  } else {
    return data
  }
  return o
}

export function colorRGBtoHex (color) {
  var rgb = color.split(',')
  var r = parseInt(rgb[0].split('(')[1])
  var g = parseInt(rgb[1])
  var b = parseInt(rgb[2].split(')')[0])
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
}



// WEBPACK FOOTER //
// ./src/utils/Tools/assist.js